export default function () {
  const widgetName = 'footerBackground';
  const widgetOpts = footerBackgroundOpts;

  function addBackground(data) {

    const items = data.items;

    const mainItem = items.find((item) => !item.Title.includes('Campbell'));
    const mainImg = mainItem.ImageWithPath.toString();
    const subItem = items.find((item) => item.Title.includes('Campbell'));
    const subImg = subItem.ImageWithPath.toString();
    if($('body').hasClass('subtheme-campbell')) {
      $('body.subtheme-campbell .footer-top .footer-bg').css('background-image', `url('${subImg}')`);
    } else {
      $('.footer-top .footer-bg').css('background-image', `url('${mainImg}')`);
    }
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function (data, owl, hasData) {
      addBackground(data);
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: false,
  });
}
